import { Box, styled } from '@mui/material';

export const ContractCardActionsContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  height: '110%',
}));
